import { Link } from "react-router-dom";
import carousel1 from './img/carousel-1.jpg';
import carousel2 from './img/carousel-2.jpg';
import about from './img/about.jpg';
import profile from './img/mobile.png';
import feature from './img/feature.jpg';
import icon07 from './img/icon/icon-07-primary.png';
import icon06 from './img/icon/icon-06-primary.png';
import icon03 from './img/icon/icon-03-primary.png';
import icon04 from './img/icon/icon-04-primary.png';
import icon10light from './img/icon/icon-10-light.png';
import icon01light from './img/icon/icon-01-light.png';
import icon06light from './img/icon/icon-06-light.png';
import icon05light from './img/icon/icon-05-light.png';
import icon08light from './img/icon/icon-08-light.png';
import icon07light from './img/icon/icon-07-light.png';
import Teamwork from './img/icon/Teamwork.png';
import Integrity from './img/icon/Integrity.png';
import Innovation from './img/icon/Innovation.png';
import CustomerFocus from './img/icon/CustomerFocus.png';
import team1 from './img/team-1.jpg';
import team2 from './img/team-2.jpg';
import team3 from './img/team-3.jpg';
import team4 from './img/team-4.jpg';

function About() {
  window.scrollTo(0,0);
    return (
        <>
        <div
      className="container-fluid page-header py-5 mb-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div className="container py-5">
        <h1 className="display-4 animated slideInDown mb-4">About Us</h1>
       
      </div>
    </div>
     {/* <!-- About Start --> */}
     <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <div
              className="position-relative overflow-hidden rounded ps-5 pt-5 h-100"
              style={{minHeight: "400px"}}
            >
              <img
                className="w-100 h-100"
                src={about}
                alt=""
                style={{objectFit: "cover"}}
              />
              <div
                className="position-absolute top-0 start-0 bg-white rounded pe-3 pb-3"
                style={{width: "200px", height: "200px"}}
              >
                <div
                  className="d-flex flex-column justify-content-center text-center bg-primary rounded h-100 p-3"
                >
                  <h1 className="text-white mb-0">25</h1>
                  <h2 className="text-white">Years</h2>
                  <h5 className="text-white mb-0">Experience</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="h-100">
              <h1 className="display-6 mb-5">
                We're Here To Assist You With Exploring Protection
              </h1>
              <p className="fs-5 text-primary mb-4">
              Our commitment to expertise, comprehensive coverage, and personalized service sets us apart as a trusted partner for our clients
              </p>
              <div className="row g-4 mb-4">
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <img
                      className="flex-shrink-0 me-3"
                      src={icon04}
                      alt=""
                    />
                    <h5 className="mb-0">Flexible Insurance Plans</h5>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <img
                      className="flex-shrink-0 me-3"
                      src={icon03}
                      alt=""
                    />
                    <h5 className="mb-0">Money Back Guarantee</h5>
                  </div>
                </div>
              </div>
              <p className="mb-4">
              Our mission is to be the most trusted and respected insurance broking company in the industry, known for our exceptional service, expertise, and commitment to our clients.
              </p>
              <div className="border-top mt-4 pt-4">
                <div className="d-flex align-items-center">
                  <img
                    className="flex-shrink-0 rounded-circle me-3"
                    src={profile}
                    alt=""
                  />
                  <h5 className="mb-0">Call Us: +91 8451807462</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- About End --> */}

    {/* <!-- Facts Start --> */}
    <div className="container-fluid overflow-hidden my-5 px-lg-0">
      <div className="container facts px-lg-0">
        <div className="row g-0 mx-lg-0">
          <div className="col-lg-6 facts-text wow fadeIn" data-wow-delay="0.1s">
            <div className="h-100 px-4 ps-lg-0">
              <h1 className="text-white mb-4">Our Vision</h1>
              <p className="text-light mb-5">
              The "Insure Karo, Secure Raho" vision likely focuses on making insurance accessible and secure through a simplified, transparent, and customer-focused approach. For insurance broking specifically, this vision would suggest that the broker's role is to act as an intermediary, helping clients find the most appropriate insurance policies based on their needs while ensuring that the process is straightforward, trustworthy, and protective for the client
              </p>
              <Link to="/home" className="align-self-start btn btn-secondary py-3 px-5"
                >More Details</Link
              >
            </div>
          </div>
          <div className="col-lg-6 facts-counter wow fadeIn" data-wow-delay="0.1s">
            <div className="h-100 px-4 ps-lg-0">
              <h1 className=" mb-4">Our Values</h1>
              <div className="row g-3">
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.1s">
                <div className="bg-light rounded h-100 p-3">
                  <div
                    className="bg-white d-flex flex-column justify-content-center text-center rounded h-100 py-4 px-3"
                  >
                    <img
                      className="align-self-center mb-3"
                      src={Integrity}
                      alt=""
                    />
                    <h5 className="mb-0">Integrity</h5>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.2s">
                <div className="bg-light rounded h-100 p-3">
                  <div
                    className="bg-white d-flex flex-column justify-content-center text-center rounded py-4 px-3"
                  >
                    <img
                      className="align-self-center mb-3"
                      src={CustomerFocus}
                      alt=""
                    />
                    <h5 className="mb-0">Customer Focus</h5>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.3s">
                <div className="bg-light rounded h-100 p-3">
                  <div
                    className="bg-white d-flex flex-column justify-content-center text-center rounded py-4 px-3"
                  >
                    <img
                      className="align-self-center mb-3"
                      src={Innovation}
                      alt=""
                    />
                    <h5 className="mb-0">Innovation</h5>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.4s">
                <div className="bg-light rounded h-100 p-3">
                  <div
                    className="bg-white d-flex flex-column justify-content-center text-center rounded h-100 py-4 px-3"
                  >
                    <img
                      className="align-self-center mb-3"
                      src={Teamwork}
                      alt=""
                    />
                    <h5 className="mb-0">Teamwork</h5>
                  </div>
                </div>
              </div>
            </div>
              {/* <Link to="/home" className="align-self-start btn btn-secondary py-3 px-5"
                >More Details</Link
              > */}
            </div>
          </div>
          {/* <div className="col-lg-6 facts-counter wow fadeIn" data-wow-delay="0.5s">
            <div className="h-100 px-4 pe-lg-0">
            <h1 className="text-white mb-4">Our Values</h1>
            Integrity: We operate with transparency, honesty, and ethics in all our interactions.
            Customer Focus: We prioritize our clients' needs and goals, providing personalized service and expert advice.
         Innovation: We stay ahead of the curve, leveraging technology and industry trends to deliver cutting-edge solutions.
Teamwork: We collaborate and support each other, fostering a culture of trust, respect, and open communication.
            </div>
          </div> */}
        </div>
      </div>
    </div>
    {/* <!-- Facts End --> */}

{/* <!-- Team Start --> */}
{/* <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center mx-auto" style={{maxWidth: "500px"}}>
          <h1 className="display-6 mb-5">Meet Our Professional Team Members</h1>
        </div>
        <div className="row g-4">
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="team-item rounded">
              <img className="img-fluid" src={team1} alt="" />
              <div className="text-center p-4">
                <h5>Full Name</h5>
                <span>Designation</span>
              </div>
              <div className="team-text text-center bg-white p-4">
                <h5>Full Name</h5>
                <p>Designation</p>
                <div className="d-flex justify-content-center">
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-twitter"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-facebook-f"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-youtube"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-linkedin-in"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="team-item rounded">
              <img className="img-fluid" src={team2} alt="" />
              <div className="text-center p-4">
                <h5>Full Name</h5>
                <span>Designation</span>
              </div>
              <div className="team-text text-center bg-white p-4">
                <h5>Full Name</h5>
                <p>Designation</p>
                <div className="d-flex justify-content-center">
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-twitter"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-facebook-f"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-youtube"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-linkedin-in"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="team-item rounded">
              <img className="img-fluid" src={team3} alt="" />
              <div className="text-center p-4">
                <h5>Full Name</h5>
                <span>Designation</span>
              </div>
              <div className="team-text text-center bg-white p-4">
                <h5>Full Name</h5>
                <p>Designation</p>
                <div className="d-flex justify-content-center">
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-twitter"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-facebook-f"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-youtube"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-linkedin-in"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="team-item rounded">
              <img className="img-fluid" src={team4} alt="" />
              <div className="text-center p-4">
                <h5>Full Name</h5>
                <span>Designation</span>
              </div>
              <div className="team-text text-center bg-white p-4">
                <h5>Full Name</h5>
                <p>Designation</p>
                <div className="d-flex justify-content-center">
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-twitter"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-facebook-f"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-youtube"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-linkedin-in"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> */}
    {/* <!-- Team End --> */}

        </>
    )
}
export default About;